<template>
  <div :class="containerClass" @click="onDocumentClick($event)">
    <div class="layout-content-wrapper">
      <AppTopBar :menu="menu" :layoutMode="layoutMode" :active="menuActive"
      :mobileMenuActive="staticMenuMobileActive" @menu-click="onMenuClick" @menuitem-click="onMenuItemClick"
      @root-menuitem-click="onRootMenuItemClick" @menu-update="setupMenu" @menu-button-click="onMenuButtonClick"></AppTopBar>

      <div class="layout-content">

        <!-- <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <Component :is="Component" />
          </transition>
        </router-view> -->

        <router-view :key="$route.path" />
        
      </div>
    </div>

    <!-- <div style="position: absolute; right: 0; top: 0; font-size: .6rem; z-index: 9999; color: #F4F3F0; cursor: default;">{{ $config.projectVersion }}</div> -->

    <!-- <AppMenu v-if="menu.length > 0" :model="menu" :layoutMode="layoutMode" :active="menuActive"
      :mobileMenuActive="staticMenuMobileActive" @menu-click="onMenuClick" @menuitem-click="onMenuItemClick"
      @root-menuitem-click="onRootMenuItemClick" @menu-update="setupMenu"></AppMenu> -->
  </div>
</template>

<script>
import AppTopBar from "./AppTopbar.vue";
import EventBus from "./event-bus";
import { useLoginStore } from "./stores/login.js";
import { mapState, mapActions } from "pinia";
import LoginService from "./service/LoginService";
import Loader from "./components/Loader.vue";
import { loadMessages } from './i18n'
import { Routes } from "./router.js";
export default {
  computed: {
    ...mapState(useLoginStore, ["getRefreshToken"]),
    ...mapState(useLoginStore, ["getDecodedJWT"]),
    ...mapState(useLoginStore, ["getAbacAnalyticsConfig"]),
    ...mapState(useLoginStore, ["getAbacConfig"]),
    ...mapState(useLoginStore, ["getTenant"]),
    ...mapState(useLoginStore, ["setDefaultLabel"]),
    containerClass() {
            return [
                "layout-wrapper",
                {
                    "layout-overlay": this.layoutMode === "overlay",
                    "layout-static": this.layoutMode === "static",
                    "layout-slim": this.layoutMode === "slim",
                    'layout-horizontal': this.layoutMode === 'horizontal',
                    "layout-sidebar-dim": this.colorScheme === "dim",
                    "layout-sidebar-dark": this.colorScheme === "dark",
                    "layout-overlay-active": this.overlayMenuActive,
                    "layout-mobile-active": this.staticMenuMobileActive,
                    "layout-static-inactive": this.staticMenuDesktopInactive && this.layoutMode === "static",
                    "p-input-filled": this.$primevue.config.inputStyle === "filled",
                    "p-ripple-disabled": !this.$primevue.config.ripple,
                },
                this.colorScheme === "light" ? this.menuTheme : "",
            ];
        },
  },
  async created() {
    this.loginService = new LoginService();
    this.checkToken(this.$router);
    this.init(this.$router);
    const messages = await loadMessages(this.$i18n.locale, this.getTenant);
    this.$i18n.setLocaleMessage(this.$i18n.locale, messages);
    this.setupMenu();
  },
  data() {
    return {
      menuActive: false,
      layoutMode: "static",
      colorScheme: "light",
      menuTheme: "layout-sidebar-darkgray",
      overlayMenuActive: false,
      staticMenuDesktopInactive: false,
      staticMenuMobileActive: false,
      menuClick: false,
      searchActive: false,
      searchClick: false,
      userMenuClick: false,
      topbarUserMenuActive: false,
      notificationMenuClick: false,
      topbarNotificationMenuActive: false,
      rightMenuClick: false,
      rightMenuActive: false,
      configActive: false,
      configClick: false,
      menu: [],
      user: null
    };
  },
  components: {
    AppTopBar,
    // AppMenu,
    Loader,
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    },
    '$i18n.locale': 'setupMenu'
  },
  methods: {
    ...mapActions(useLoginStore, [
      "logout",
      "init",
      "checkToken"
    ]),
    setupMenu() {
      console.log("setupMenu APP");
      this.menu = [];

      // Appliances
      if(this.getAbacConfig?.role_def?.device) {
        this.menu.push({
          items: [
            {
              label: this.$t("menu_appliances"),
              image: "/icons/oven.svg",
              to: "/appliances",
              key: "appliances",
            },
          ],
        });
      }

      // Users
      if (this.getAbacConfig?.role_def?.user) {
        this.menu.push({
          items: [{ 
            label: this.$t("menu_users"), 
            icon: "pi pi-fw pi-users", 
            to: "/users",
            key: "users",
          }],
        });
      }

      // Analytics
      if (this.getAbacAnalyticsConfig?.sections) {
        var analyticSectionsItems = [];
        this.getAbacAnalyticsConfig.sections.forEach(section => {
          var analyticSubmenu = { label: this.$t("menu_analytics_"+section.id), to: `${Routes.ANALYTICS}/` + this.setDefaultLabel(section.id) };
          analyticSectionsItems.push(analyticSubmenu);
        });
        this.menu.push({
          items: [
            {
              label: this.$t("menu_analytics"),
              icon: "pi pi-fw pi-chart-bar",
              items: analyticSectionsItems,
              key: "analytics",
            },
          ],
        });
      }

      // OTA Campaigns
      if (this.getAbacConfig?.role_def?.ota) {
        this.menu.push({
          items: [
            {
              label: this.$t("menu_ota"),
              image: "/icons/OTA.svg",
              // icon: "pi pi-fw pi-upload",
              to: "/ota",
              key: "ota",
            },
          ],
        });
      }

      // TAGS
      if (this.getAbacConfig?.role_def?.tags_page) {
        this.menu.push({
          items: [
            {
              label: this.$t("menu_tags"),
              icon: "pi pi-fw pi-tags",
              to: "/tags",
              key: "tags",
            },
          ],
        });
      }

      // Reports
      if (this.getAbacConfig?.role_def?.reports) {
        this.menu.push({
          items: [
            {
              label: this.$t("menu_reports"),
              icon: "pi pi-fw pi-file",
              to: "/reports",
              key: "reports",
            },
          ],
        });
      }

      // Reports
      if (this.getAbacConfig?.role_def?.pending_dealers) {
        this.menu.push({
          items: [
            {
              label: this.$t("menu_pendingDealers"),
              image: "/icons/pending_users.svg",
              to: "/pending-dealers",
              key: "pending-dealers",
            },
          ],
        });
      }

      // Statistics
      if (this.getAbacConfig?.role_def?.most_visited_pages) {
        this.menu.push({
          items: [
            {
              label: this.$t("menu_stats"),
              icon: "pi pi-eye",
              to: "/most-visited-pages",
              key: "stats",
            },
          ],
        });
      }

      // Verbose appliances
      if (this.getAbacConfig?.role_def?.appliance_verbose) {
        this.menu.push({
          items: [
            {
              label: this.$t("menu_verboseAppliances"),
              icon: "pi pi-exclamation-triangle",
              to: "/verbose",
              key: "verbose",
            },
          ],
        });
      }
    },
    
    onDocumentClick() {
      if (!this.searchClick && this.searchActive) {
        this.onSearchHide();
      }

      if (!this.userMenuClick) {
        this.topbarUserMenuActive = false;
      }

      if (!this.notificationMenuClick) {
        this.topbarNotificationMenuActive = false;
      }

      if (!this.rightMenuClick) {
        this.rightMenuActive = false;
      }

      if (!this.menuClick) {
        if (this.isSlim()) {
          EventBus.emit("reset-active-index");
          this.menuActive = false;
        }

        if (this.overlayMenuActive || this.staticMenuMobileActive) {
          this.hideOverlayMenu();
        }

        this.unblockBodyScroll();
      }

      if (this.configActive && !this.configClick) {
        this.configActive = false;
      }

      this.searchClick = false;
      this.configClick = false;
      this.userMenuClick = false;
      this.rightMenuClick = false;
      this.notificationMenuClick = false;
      this.menuClick = false;
    },
    onMenuClick() {
      this.menuClick = true;
    },
    onMenuButtonClick(event) {
      this.menuClick = true;
      this.topbarUserMenuActive = false;
      this.topbarNotificationMenuActive = false;
      this.rightMenuActive = false;

      if (this.isOverlay()) {
        this.overlayMenuActive = !this.overlayMenuActive;
      }

      if (this.isDesktop()) {
        this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
      } else {
        this.staticMenuMobileActive = !this.staticMenuMobileActive;
        if (this.staticMenuMobileActive) {
          this.blockBodyScroll();
        } else {
          this.unblockBodyScroll();
        }
      }

      event.preventDefault();
    },
    onMenuItemClick(event) {
      if (!event.item.items) {
        EventBus.emit("reset-active-index");
        this.hideOverlayMenu();
      }
      if (!event.item.items && this.isSlim()) {
        this.menuActive = false;
      }
    },
    onRootMenuItemClick() {
      this.menuActive = !this.menuActive;
    },
    onTopbarUserMenuButtonClick(event) {
      this.userMenuClick = true;
      this.topbarUserMenuActive = !this.topbarUserMenuActive;

      this.hideOverlayMenu();

      event.preventDefault();
    },
    onTopbarNotificationMenuButtonClick(event) {
      this.notificationMenuClick = true;
      this.topbarNotificationMenuActive = !this.topbarNotificationMenuActive;

      this.hideOverlayMenu();

      event.preventDefault();
    },
    toggleSearch() {
      this.searchActive = !this.searchActive;
      this.searchClick = true;
    },
    onSearchClick() {
      this.searchClick = true;
    },
    onSearchHide() {
      this.searchActive = false;
      this.searchClick = false;
    },
    onRightMenuClick() {
      this.rightMenuClick = true;
    },
    onRightMenuButtonClick(event) {
      this.rightMenuClick = true;
      this.rightMenuActive = !this.rightMenuActive;
      this.hideOverlayMenu();
      event.preventDefault();
    },
    onConfigClick() {
      this.configClick = true;
    },
    onConfigButtonClick() {
      this.configActive = !this.configActive;
      this.configClick = true;
    },
    hideOverlayMenu() {
      this.overlayMenuActive = false;
      this.staticMenuMobileActive = false;
      this.unblockBodyScroll();
    },
    blockBodyScroll() {
      if (document.body.classList) {
        document.body.classList.add("blocked-scroll");
      } else {
        document.body.className += " blocked-scroll";
      }
    },
    unblockBodyScroll() {
      if (document.body.classList) {
        document.body.classList.remove("blocked-scroll");
      } else {
        document.body.className = document.body.className.replace(
          new RegExp(
            "(^|\\b)" + "blocked-scroll".split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
      }
    },
    isSlim() {
      return this.layoutMode === "slim";
    },
    isOverlay() {
      return this.layoutMode === "overlay";
    },
    isDesktop() {
      return window.innerWidth > 1091;
    },
  },
};
</script>

<style lang="scss">
@import "App.scss";
.active-menuitem {
  border-radius: 8px;
  background-color: #968870;
}


.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity .5s ease-out;
}

</style>
